import { MutationTree } from 'vuex';
import { ProductInformationState, ProductInformation } from './types';

export const mutations: MutationTree<ProductInformationState> = {
    productInformationLoaded(state, payload: ProductInformation) {
        state.error = false;
        state.productInformation = payload;
    },
    productInformationError(state) {
        state.error = true;
        state.productInformation = undefined!;
    }
};